// Copyright (c) 2016 Deere & Company

import ClaimTypes, {getDefaultState as getDefaultClaimTypesState} from './claim-types';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {getDefaultState as getDefaultDateRangeState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    claimNumber: t.String,
    claimTypes: ClaimTypes,
    creditMemo: t.String,
    dateIssued: DateRange,
    invoiceRequest: t.String,
    pin: t.String,
    workOrderOne: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        claimNumber: '',
        claimTypes: getDefaultClaimTypesState(),
        creditMemo: '',
        dateIssued: getDefaultDateRangeState(),
        invoiceRequest: '',
        pin: '',
        workOrderOne: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state/criteria.js